import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { CheckboxInput, InputBlock } from 'ecs-react-components/dist/index.es';

import { messages } from './NameRelation.i18n';

class NameRelation extends React.Component {
  render = () => {
    const {
      fields,
      relationships,
      isPrimary,
      onInputChange,
    } = this.props;

    const relationshipOptions = relationships.map((r) => {
      const option = {};
      option.key = r.relationshipId;
      option.value = r.relationshipId;
      option.displayValue = r.relationshipDisplay;
      return option;
    });

    let primaryContactCheckboxAttributes = {};
    if (isPrimary) {
      primaryContactCheckboxAttributes = { tabIndex: 0 };
    }

    const { formatMessage } = this.props.intl;
    return (
      <div className="contact-section">
        <h4 className="mt-2" tabIndex="0"><FormattedMessage { ...messages.nameRelation.title } /></h4>
        <div className="row">
          <div className="form-group col">
            <InputBlock
              id="contactFirstName"
              labelText={ <FormattedMessage { ...messages.nameRelation.firstName } /> }
              type="text"
              field={ fields.contactFirstName }
              formGroup
              onChange={onInputChange}
              rowClass="mb-3"
            />
            <InputBlock
              id="contactLastName"
              labelText={ <FormattedMessage { ...messages.nameRelation.lastName } /> }
              type="text"
              field={ fields.contactLastName }
              formGroup
              onChange={onInputChange}
              rowClass="mb-3"
            />
            <InputBlock
              type="select"
              id="relationshipId"
              labelText={ <FormattedMessage { ...messages.nameRelation.relation } /> }
              field={fields.relationshipId}
              options={relationshipOptions}
              placeHolder={formatMessage(messages.nameRelation.selectOne)}
              qaTag="relationshipSelect"
              formGroup
              rowClass="mb-3"
            />
          </div>
          <div className="form-group col">
            <label className="form-label" htmlFor="otherInformation" tabIndex="0">
              <FormattedMessage { ...messages.nameRelation.otherInformation } />
            </label>
            <div {...primaryContactCheckboxAttributes}>
              <CheckboxInput
                type="checkbox"
                field={fields.isPrimaryContact}
                qaTag="isPrimaryContact"
                disabled={isPrimary}
                modalConfig={{
                  title: messages.isPrimaryModal.title,
                  message: messages.isPrimaryModal.message,
                  submitBtnText: messages.isPrimaryModal.submitBtnText,
                  hideBtnText: messages.isPrimaryModal.hideBtnText,
                }}
              >
                <FormattedMessage { ...messages.nameRelation.primaryContact } />
              </CheckboxInput>
            </div>
            <div>
              <CheckboxInput
                type="checkbox"
                field={fields.isNextOfKin}
                qaTag="isNextOfKin"
              >
                <FormattedMessage { ...messages.nameRelation.nextOfKin } />
              </CheckboxInput>
            </div>
            <div>
              <CheckboxInput
                type="checkbox"
                field={fields.providesTransport}
                qaTag="isProvidesTransport"
              >
                <FormattedMessage { ...messages.nameRelation.providesTransportation } />
              </CheckboxInput>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NameRelation.propTypes = {
  fields: PropTypes.object,
  relationships: PropTypes.array,
  intl: PropTypes.object,
  isPrimary: PropTypes.bool,
  onInputChange: PropTypes.func,
};

export default (injectIntl(NameRelation));
